import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import SectionTitle from '..//SectionTitle.js';
import TreeView from '@material-ui/lab/TreeView';
import { TreeItemStyled, PlusSquare, MinusSquare, CloseSquare } from './TreeItemStyled';
// https://material-ui.com/components/tree-view/

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    padding: '0 0.5rem',
  },
});

const TreeListDisplay = ({title=null, data, taxonomy, onClick}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {title !== null ? (<SectionTitle title={title} />) : null}
      <TreeView
        className={classes.root}
        defaultCollapseIcon={<MinusSquare />}
        defaultExpandIcon={<PlusSquare />}
        onNodeSelect={(event, value) => onClick(value, taxonomy)}
      >
        {data.map(item => {
          return (
            <TreeItemStyled
              nodeId={item.name}
              key={item.id}
              label={(<Typography variant="body2">{item.name}</Typography>)}
              endIcon={<CloseSquare />}
            >
              {item.children.map(child => {
                return (
                  <TreeItemStyled
                    nodeId={child.name}
                    key={child.id}
                    label={(<Typography variant="body2">{child.name}</Typography>)}
                  />
                );}
              )}
            </TreeItemStyled>
          );})}
      </TreeView>
    </div>
  );
};

TreeListDisplay.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  taxonomy: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TreeListDisplay;
